import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';
import {
  TopBarContainer,
  SideNavContainer,
  SelectAuctionContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';
import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './Styles';
// import ProductDetailsNew from '../../../components/Dashboard/Products/ProductDetailsNew';
import ProductDetails from '../../../components/Dashboard/Products/ProductDetailsNew';
import { dashboardBreadcrumb } from '../../../data/routes';
const AdminLayout = (props) => {
  const {
    AuthStore: { memberName },
  } = useStores();

  const auctionID = props.AuctionID;
  const laneID = props.LaneID;
  const productID = props.ProductID;

  const items = [
    dashboardBreadcrumb,
    { to: '/auctions', label: 'Auctions' },
    { to: '/auction/' + auctionID + '/products', label: 'Products' },
    {
    //   to: '/auction/' + auctionID + '/lane/' + laneID + '/product/' + productID,
      label: 'Product Details',
    },
  ];

  return (
    <Layout>
      <TopBarContainer
        title={`Products`}
        // laneName={`auctionLaneName`}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer>
          {items.map(({ to, label }) =>
              to ? (
                <Link key={to} to={to}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>

        {/* <PageNavRightContainer>
                    <SelectAuctionContainer title='Views' noneselectedText='---Select Auction---' />
                </PageNavRightContainer> */}
      </PageNavContainer>
      <MainContainer>
        <ProductDetails
          AuctionID={props.AuctionID}
          LaneID={props.LaneID}
          ProductID={props.ProductID}
        />
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);
